/*********************** Custom JS for Boost AI Search & Discovery  ************************/
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  
  (componentRegistry) => {
    const changeProductImageResolution = {
      name: "Change Product Image resolution",
      apply() {
        return {
          props(props) {
      console.log(props)
            props.size = 800;
            return props;
          },
        };
      },
    };
    componentRegistry.useComponentPlugin(
      "HeaderImage",
      changeProductImageResolution
    );
  },
]);

// Comment function based on client requirement
// window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
//    (componentRegistry) => {
//       componentRegistry.useModulePlugin('CartAPI', {
//          name: 'Integrate theme cart',
//          apply(builder) {
//             builder.on('methodFulfilled', 'addToCart', async (payload) => {
//               if (payload.result.ok) {
//                fetch(`${routes.cart_url}?section_id=cart-drawer`)
//                   .then((response) => response.text())
//                   .then((responseText) => {
//                      const cartDrawerElm = document.querySelector('cart-drawer');
//                      const html = new DOMParser().parseFromString(responseText, 'text/html');
//                      const newCartDrawerHTML = html.querySelector('#CartDrawer').innerHTML;
//                      cartDrawerElm.querySelector('#CartDrawer').innerHTML = newCartDrawerHTML;
//                      cartDrawerElm.classList.remove('is-empty');
//                      cartDrawerElm.open();
//                      cartDrawerElm.querySelector('#CartDrawer-Overlay').addEventListener('click', 
//                      function(){
//                        cartDrawerElm.close();
//                      });
//                   });
//               }
//             });
//          },
//       });
//    }
// ]);


// window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
//     (componentRegistry) => {
//           componentRegistry.useModulePlugin('CartAPI', {
//           name: 'Custom onSucces add to cart',
//           apply(builder) {
//             builder.on('methodFulfilled', 'addToCart', async (payload) => {
//               if(window.__wsUpdCartDrawer) {
//                   window.__wsUpdCartDrawer();
//               }
//               return payload;
//             });
//           },
//         });
    
//     }
//   ]);

window.boostSDAppConfig.generalSettings.enableCartOnPages = ['collection','product'];